import React, { useEffect, useState } from "react";
import "../../components/dataUploadLayout/dataUploadHomeScreen/excelUpload/widgets/masterDataList/masterData.css";
import { Button } from "@mui/material";
import { DomainValue } from "../../services/mdmService/types";
import MasterRenderCard from "../../components/dataUploadLayout/dataUploadHomeScreen/excelUpload/widgets/masterDataList/masterRenderCard";
import { useNavigate } from "react-router-dom";

interface UpdatedMasterDataTableProps {
  showBeatMapping: boolean;
  mdmData: DomainValue[];
  setMdmData: React.Dispatch<React.SetStateAction<DomainValue[]>>;
  setSelectedMaster: React.Dispatch<
    React.SetStateAction<DomainValue | undefined>
  >;
  selectedMaster: DomainValue | undefined;
  handleScreenSwitch: (
    screen: "default" | "logs" | "edit" | "division"
  ) => void;
}

interface MastersProps {
  showBeatMapping: boolean;
  data: DomainValue[];
  setSelectedMaster: React.Dispatch<
    React.SetStateAction<DomainValue | undefined>
  >;
  selectedMaster: DomainValue;
  handleScreenSwitch: (
    screen: "default" | "logs" | "edit" | "division"
  ) => void;
}

const MastersComponent: React.FC<MastersProps> = ({
  data,
  showBeatMapping,
  setSelectedMaster,
  selectedMaster,
  handleScreenSwitch,
}) => {
  const [expandedMandatoryCard, setExpandedMandatoryCard] = useState<
    number | null
  >(null);
  const [expandedOptionalCard, setExpandedOptionalCard] = useState<
    number | null
  >(null);
  console.log("showBeatMapping",showBeatMapping);
  const [isSelected, setIsSelected] = useState(false);

  // Separate Mandatory and Optional Masters
  const mandatoryMasters = data.filter((master) => master.mandatory);
  const optionalMasters = data.filter((master) => !master.mandatory);
  const navigate = useNavigate();


  const groupByParentTemplate = (masters: DomainValue[]) => {
    const groupedMasters: {
      [key: string]: {
        masters: DomainValue[];
        description: string;
        icon: string;
        multipleOptionMasters?: DomainValue[];
      };
    } = {};
  
    masters.forEach((master) => {
        const displayGroupName = master.parentTemplate
          ? master.parentTemplate
          : master.name;
        const displayGroupDescription = master.parentDescription ?? "";
        const displayGroupIcon = master.parentIcon ?? "";
  
        // Initialize group if it doesn't exist
        if (!groupedMasters[displayGroupName]) {
          groupedMasters[displayGroupName] = {
            masters: [],
            description: displayGroupDescription,
            icon: displayGroupIcon,
          };
        }
  
        // Add master to the group
        groupedMasters[displayGroupName].masters.push(master);
    });
  
    return groupedMasters;
  };
  

  useEffect(() => {
    if (selectedMaster) {
      const groupKey = selectedMaster.parentTemplate || selectedMaster.id;

      // Check if the selected master is in the mandatory masters group
      const mandatoryGroupIndex = Object.keys(
        groupedMandatoryMasters
      ).findIndex((groupName) => groupName === groupKey);

      // Check if the selected master is in the optional masters group
      const optionalGroupIndex = Object.keys(groupedOptionalMasters).findIndex(
        (groupName) => groupName === groupKey
      );

      // Expand the correct mandatory card if found
      if (mandatoryGroupIndex !== -1) {
        setExpandedMandatoryCard(mandatoryGroupIndex);
      }

      // Expand the correct optional card if found
      if (optionalGroupIndex !== -1) {
        setExpandedOptionalCard(optionalGroupIndex);
      }
    }
  }, [selectedMaster]);

  const groupedMandatoryMasters = groupByParentTemplate(mandatoryMasters);
  const groupedOptionalMasters = groupByParentTemplate(optionalMasters);

  return (
    <div style={{ gap: "20px", paddingTop: "20px", paddingBottom: "20px" }}>
      {/* Mandatory Masters */}
       {mandatoryMasters.length > 0 && (
      <div className="mandatory-master" style={{ flex: 1 }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h2>Mandatory Masters</h2>
          {Object.values(groupedMandatoryMasters).some((group) =>
            group.masters.some((master) => master.id === "Division")
          ) && (
            <Button
              variant="outlined"
              onClick={(e) => {
                handleScreenSwitch("division");
              }}
              sx={{
                color: "#434343",
                borderColor: "#CBCBCB",
                padding: "5px",
                borderRadius: "10px",
                margin: "5px",
                marginRight: "15px",
              }}
            >
              {`Update Division >`}
            </Button>
          )}
        </div>
        {Object.keys(groupedMandatoryMasters).map((groupName, index) => {
          // Ensure you're checking the masters array correctly
          const currentMasters =
            groupedMandatoryMasters[groupName]?.masters || [];

          // Filter out the "Division" master by ID
          const filteredMasters = currentMasters.filter(
            (master) => master.id !== "Division"
          );
          // && master.id !== "PJPVisitPlan"

          // Check if there are masters left after filtering
          if (filteredMasters.length > 0) {
            return (
              <MasterRenderCard
                key={index}
                index={index}
                groupedMasters={filteredMasters}
                currentMasterGroupName={groupName}
                setExpandedMasterIndex={setExpandedMandatoryCard}
                expandedMasterIndex={expandedMandatoryCard}
                groupedMandatoryMasters={groupedMandatoryMasters}
                selectedMaster={selectedMaster}
                setSelectedMaster={setSelectedMaster}
              />
            );
          }
          return null; // Skip rendering this group if no masters remain
        })}
      </div>
       )}

      {/* Optional Masters */}
        {optionalMasters.length > 0 && (
      <div className="optional-master" style={{ paddingTop: "20px",flex: 1 }}>
        <h2>Optional Masters</h2>
        {Object.keys(groupedOptionalMasters).map((groupName, index) => (
          <MasterRenderCard
            index={index}
            groupedMasters={optionalMasters}
            currentMasterGroupName={groupName}
            setExpandedMasterIndex={setExpandedOptionalCard}
            expandedMasterIndex={expandedOptionalCard}
            groupedMandatoryMasters={groupedOptionalMasters}
            selectedMaster={selectedMaster}
            setSelectedMaster={setSelectedMaster}
          />
        ))}
      </div>
      )}
      {showBeatMapping &&
        <div className="optional-master" style={{ paddingTop: "20px", flex: 1 }}>
          <h2>Master Migration</h2>
          <div className="single-option-card">
            <div
              onClick={() => {setIsSelected(!isSelected);navigate("/dashboard/updatedFlowMDM/beatMigration")}}
              style={{
                backgroundColor: isSelected ? "rgb(234, 248, 249)" : "#ffffff",
                display: "flex",
                alignItems: "center",
              }}
            >
              <h4>1.</h4>
              <div
                style={{
                  width: "45px",
                  height: "45px",
                  marginRight: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#FFFFFF",
                  border: "1px solid #00C6B1",
                  boxShadow: "0px 0px 8px #0000001A",
                  borderRadius: "10px",
                }}
              >
                <img
                  src={"https://d2nvw4ekms3xzy.cloudfront.net/salind/images/Group%2061721@2x-uUyPwMVsoyRI.png"}
                  alt="icon"
                  style={{ width: "50%" }}
                />
              </div>
              <div className="text-container">
                <h3>Beat Migration</h3>
                <h6>
                  Contains all information about all distributor within the system
                </h6>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  );
};

const UpdatedMasterDataTable = (props: UpdatedMasterDataTableProps) => {
  return props.mdmData !== undefined && props.mdmData !== null ? (
    <MastersComponent
      showBeatMapping={props.showBeatMapping}
      data={props.mdmData}
      setSelectedMaster={props.setSelectedMaster}
      selectedMaster={props.selectedMaster!}
      handleScreenSwitch={props.handleScreenSwitch}
    />
  ) : (
    <></>
  );
};

export default UpdatedMasterDataTable;
